<template>
    <div class="tw-px-4">
        <div class="tw-grid tw-grid-cols-12 tw-gap-4">
            <div class="lg:tw-col-span-3 tw-col-span-12">
                <div class="tw-h-[250px]x tw-pb-8 tw-p-4 tw-bg-white tw-border tw-border-solid tw-border-primary-200 tw-rounded-lg">
                    <div class="tw-flex tw-justify-end">
                        <button class="tw-text-gray-500 tw-text-sm tw-font-semibold">Edit</button>
                    </div>

                    <div class="tw-flex tw-items-center tw-justify-center tw-mt-4 tw-flex-col">
                        <div class="tw-w-[100px] tw-h-[100px] tw-rounded-full tw-bg-primary-800 tw-flex tw-items-center tw-justify-center tw-relative">
                            <template v-if="$user.profile_image">
                                <img :src="$user.profile_image" class="tw-w-full tw-h-full tw-object-cover tw-rounded-full tw-bg-white" />
                            </template>
                            <template v-else>
                                <icon icon="solar:user-circle-linear" class="tw-text-primary-50 tw-text-6xl tw-font-semibold " />
                            </template>

                            <div class="tw-absolute tw-bottom-1 tw-right-1 tw-w-[20px] tw-h-[20px] tw-rounded-full tw-bg-primary-500 tw-flex tw-items-center tw-justify-center tw-border-4 tw-border-solid tw-border-white"></div>
                        </div>

                        <h1 class="tw-text-primary-950 tw-text-lg md:tw-text-2xl tw-font-semibold tw-mt-2 tw-text-center">{{ $user.name }}</h1>
                        <h2 class="tw-text-primary-950 tw-text-sm tw-font-semibold tw-mt-1 tw-text-center">CEO, Date Company</h2>
                    </div>


                    
                </div>

                <div class="tw-mt-4">
                    <h1 class="tw-text-primary-950 tw-text-xl tw-font-semibold">My Companies</h1>
                </div>

                <!-- Companies found -->
                <div v-if="myCompaniesFetched && myCompanies.length > 0">
                    <MyCompanyCard v-for="company in myCompanies" :key="company.id" :company="company" />
                </div>

                <!-- No companies found -->
                <div v-else-if="myCompaniesFetched && myCompanies.length === 0">
                    <div class="tw-bg-white tw-border tw-border-solid tw-border-primary-200 tw-rounded-lg tw-mt-4 tw-p-6 tw-text-center">
                        <icon icon="solar:buildings-3-linear" class="tw-text-gray-400 tw-text-5xl tw-mb-3 tw-mx-auto" />
                        <p class="tw-text-gray-500 tw-text-lg tw-font-medium tw-mb-1">No Companies Found</p>
                        <p class="tw-text-gray-400 tw-text-sm">You don't have any companies associated with your account yet.</p>
                    </div>
                </div>

                <!-- Loading state -->
                <div v-else>
                    <div v-for="i in 1" :key="i" class="tw-bg-white tw-border tw-border-solid tw-border-primary-200 tw-rounded-lg tw-mt-4 tw-flex tw-gap-4 tw-p-4">
                        <!-- Logo placeholder -->
                        <div class="tw-min-w-[60px] tw-min-h-[60px] tw-bg-gray-200 tw-animate-pulse tw-rounded-lg tw-flex-shrink-0"></div>
                        
                        <!-- Text content placeholder -->
                        <div class="tw-flex tw-flex-col tw-justify-center tw-gap-1 tw-flex-1">
                            <!-- Company name placeholder -->
                            <div class="tw-h-5 tw-bg-gray-200 tw-animate-pulse tw-rounded tw-max-w-[200px]"></div>
                            <!-- Role placeholder -->
                            <div class="tw-h-4 tw-bg-gray-200 tw-animate-pulse tw-rounded tw-w-20"></div>
                        </div>
                        
                        <!-- Action button placeholder -->
                        <div class="tw-flex tw-items-center tw-justify-center">
                            <div class="tw-w-6 tw-h-6 tw-bg-gray-200 tw-animate-pulse tw-rounded"></div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="lg:tw-col-span-6 tw-col-span-12">
                <div class="tw-aspect-[34/11] tw-rounded-lg tw-overflow-hidden tw-pointer-events-none tw-bg-primary-800">
                    <iframe 
                        width="100%" 
                        height="100%" 
                        src="https://www.youtube.com/embed/5ngD7XZGN74?si=Gq9FMDyU_OEMPBzI&autoplay=1&mute=1&controls=0&loop=1&playlist=5ngD7XZGN74&rel=0&modestbranding=1&showinfo=0" 
                        title="YouTube video player" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        referrerpolicy="strict-origin-when-cross-origin" 
                        allowfullscreen
                        class="tw-rounded-lg">
                    </iframe>
                </div>

                <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-mt-4">
                    <router-link :to="{name: 'shared.my-eshow'}" class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-200 tw-flex tw-items-center tw-justify-center tw-relative tw-overflow-hidden hover:tw-opacity-90 tw-transition-opacity">
                        <div class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-opacity-75 tw-hidden" style="background-image: url('https://v1.thefoodeshow.com/assets/front_office/imgs/public/image-57@2x-a10cd7883c643a8cb2b49e680cc615e8.png');"></div>
                        <p class="tw-text-primary-950 tw-text-lg md:tw-text-2xl tw-font-semibold tw-z-10">My Eshow</p>
                    </router-link>
                    <router-link :to="{name: 'shared.companies'}" class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-200 tw-flex tw-items-center tw-justify-center tw-relative tw-overflow-hidden hover:tw-opacity-90 tw-transition-opacity">
                        <div class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-opacity-75 tw-hidden" style="background-image: url('https://v1.thefoodeshow.com/assets/front_office/imgs/public/image-57@2x-a10cd7883c643a8cb2b49e680cc615e8.png');"></div>
                        <p class="tw-text-primary-950 tw-text-lg md:tw-text-2xl tw-font-semibold tw-z-10">Exhibitors</p>
                    </router-link>

                    <router-link :to="{name: 'shared.vib-buyers'}" class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-500 tw-flex tw-items-center tw-justify-center tw-relative tw-overflow-hidden hover:tw-opacity-90 tw-transition-opacity">
                        <div class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-opacity-75 tw-hidden" style="background-image: url('https://v1.thefoodeshow.com/assets/front_office/imgs/public/image-57@2x-a10cd7883c643a8cb2b49e680cc615e8.png');"></div>
                        <p class="tw-text-primary-50 tw-text-lg md:tw-text-2xl tw-font-semibold tw-z-10">VIB - Buyers</p>
                    </router-link>
                    <router-link :to="{name: 'shared.community'}" class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-500 tw-flex tw-items-center tw-justify-center tw-relative tw-overflow-hidden hover:tw-opacity-90 tw-transition-opacity">
                        <div class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-opacity-75 tw-hidden" style="background-image: url('https://v1.thefoodeshow.com/assets/front_office/imgs/public/image-57@2x-a10cd7883c643a8cb2b49e680cc615e8.png');"></div>
                        <p class="tw-text-primary-50 tw-text-lg md:tw-text-2xl tw-font-semibold tw-z-10">Community</p>
                    </router-link>

                    <router-link :to="{name: 'shared.speakers'}" class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-500 tw-flex tw-items-center tw-justify-center tw-relative tw-overflow-hidden hover:tw-opacity-90 tw-transition-opacity">
                        <div class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-opacity-75 tw-hidden" style="background-image: url('https://v1.thefoodeshow.com/assets/front_office/imgs/public/image-57@2x-a10cd7883c643a8cb2b49e680cc615e8.png');"></div>
                        <p class="tw-text-primary-50 tw-text-lg md:tw-text-2xl tw-font-semibold tw-z-10">Speakers</p>
                    </router-link>
                    <router-link :to="{name: 'shared.agenda'}" class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-500 tw-flex tw-items-center tw-justify-center tw-relative tw-overflow-hidden hover:tw-opacity-90 tw-transition-opacity">
                        <div class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-opacity-75 tw-hidden" style="background-image: url('https://v1.thefoodeshow.com/assets/front_office/imgs/public/image-57@2x-a10cd7883c643a8cb2b49e680cc615e8.png');"></div>
                        <p class="tw-text-primary-50 tw-text-lg md:tw-text-2xl tw-font-semibold tw-z-10">Agenda</p>
                    </router-link>

                    <router-link :to="{name: 'shared.products'}" class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-900 tw-flex tw-items-center tw-justify-center tw-relative tw-overflow-hidden hover:tw-opacity-90 tw-transition-opacity">
                        <div class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-opacity-75 tw-hidden" style="background-image: url('https://v1.thefoodeshow.com/assets/front_office/imgs/public/image-57@2x-a10cd7883c643a8cb2b49e680cc615e8.png');"></div>
                        <p class="tw-text-primary-50 tw-text-lg md:tw-text-2xl tw-font-semibold tw-z-10">Products</p>
                    </router-link>
                    <router-link :to="{name: 'shared.services'}" class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-900 tw-flex tw-items-center tw-justify-center tw-relative tw-overflow-hidden hover:tw-opacity-90 tw-transition-opacity">
                        <div class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-opacity-75 tw-hidden" style="background-image: url('https://v1.thefoodeshow.com/assets/front_office/imgs/public/image-57@2x-a10cd7883c643a8cb2b49e680cc615e8.png');"></div>
                        <p class="tw-text-primary-50 tw-text-lg md:tw-text-2xl tw-font-semibold tw-z-10">Services</p>
                    </router-link>

                    <router-link :to="{name: 'shared.foodshow-on-demand'}" class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-orange-200 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-relative tw-overflow-hidden hover:tw-opacity-90 tw-transition-opacity">
                        <div class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-opacity-75 tw-hidden" style="background-image: url('https://v1.thefoodeshow.com/assets/front_office/imgs/public/image-57@2x-a10cd7883c643a8cb2b49e680cc615e8.png');"></div>
                        <icon icon="solar:clapperboard-play-linear" class="tw-text-primary-800 tw-text-3xl tw-font-semibold tw-z-10" />
                        <p class="tw-text-primary-800 tw-text-lg md:tw-text-2xl tw-font-semibold tw-z-10">VOD</p>
                    </router-link>
                    <router-link :to="{name: 'shared.help-desk'}" class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-sky-600 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-relative tw-overflow-hidden hover:tw-opacity-90 tw-transition-opacity">
                        <div class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-opacity-75 tw-hidden" style="background-image: url('https://v1.thefoodeshow.com/assets/front_office/imgs/public/image-57@2x-a10cd7883c643a8cb2b49e680cc615e8.png');"></div>
                        <icon icon="solar:help-linear" class="tw-text-primary-50 tw-text-3xl tw-font-semibold tw-z-10" />
                        <p class="tw-text-primary-50 tw-text-lg md:tw-text-2xl tw-font-semibold tw-z-10">Help Desk</p>
                    </router-link>
                </div>

                <SponsorBand class="tw-mt-6" />

            </div>

            <div class="lg:tw-col-span-3 tw-col-span-12 tw-h-[600px] tw-bg-primary-600 tw-rounded-lg tw-border tw-border-solid tw-border-primary-200">

            </div>

        </div>

        
    </div>
  </template>
  
  <script setup>
    import { computed } from 'vue';
    import MyCompanyCard from '@/components/dashboard/exhibitor/MyCompanyCard';
    import { useStateStore } from '@/stores/app/state';
    import SponsorBand from '@/components/dashboard/SponsorBand.vue';

    const stateStore = useStateStore();

    const myCompanies = computed(() => stateStore.myCompanies.data);
    const myCompaniesFetched = computed(() => stateStore.myCompanies.fetched);
  </script>
  
  <style></style>
  